import ERC20_ABI from 'abis/erc20.json'
import ISLAND_ABI from 'abis/island.json'
import { REFETCH_POLICY_FAST } from 'config/RefetchPolicies'
import { useMemo } from 'react'
import { Abi, Address } from 'viem'

import { useReadContractMultiple } from './useReadContractMultiple'

export function useIslandUnderlyingBalances(islandAddress?: Address): {
  underlyingAmount0: bigint | undefined
  underlyingAmount1: bigint | undefined
  totalSupply: bigint | undefined
  loading: boolean
} {
  const contracts = useMemo(() => {
    if (!islandAddress) return []
    return [
      {
        address: islandAddress,
        abi: ISLAND_ABI as Abi,
        functionName: 'getUnderlyingBalances',
      },
      {
        address: islandAddress,
        abi: ERC20_ABI as Abi,
        functionName: 'totalSupply',
      },
    ]
  }, [islandAddress])

  const { data, isLoading } = useReadContractMultiple({
    contracts,
    query: {
      ...REFETCH_POLICY_FAST,
      enabled: contracts.length > 0,
    },
  })

  const underlyingResult = data?.[0]?.result as [bigint, bigint] | undefined
  const totalSupply = data?.[1]?.result as bigint | undefined

  return {
    underlyingAmount0: underlyingResult?.[0],
    underlyingAmount1: underlyingResult?.[1],
    totalSupply,
    loading: isLoading,
  }
}
